const React = require("react");

import { Div, FontIcon, InfoIcon } from "components/Base";

const Page = ({ children, styles = {} }) => (
  <Div
    width={1}
    bg="white"
    style={{
      padding: "30px 50px",
      ...styles
    }}
  >
    {children}
  </Div>
);

const Divider = ({ my = 8, bg = "gray3" }) => (
  <Div
    width={1}
    my={my}
    bg={bg}
    style={{
      height: "1px"
    }}
  />
);

const Label = ({ children, tooltip, required, ...props }) => (
  <Div
    display="row.flex-start.center"
    color="black"
    fw={3}
    fs={3}
    mb={1}
    {...props}
  >
    {children}
    {required ? <span style={{ color: "#ff3c3c" }}>&nbsp;*</span> : null}
    {tooltip ? <InfoIcon ml={1} color="gray5" tooltip={tooltip} /> : null}
  </Div>
);

const Title = ({
  icon,
  iconFrom = "material-icons",
  iconColor = "gray3",
  title,
  description,
  descriptionColor = "gray6",
  buttons,
  mb = 8,
  ...props
}) => (
  <Div
    display="row.space-between.center"
    mb={mb}
    pb={5}
    bb={1}
    bc="gray3"
    {...props}
  >
    <Div display="row.flex-start.center">
      <FontIcon fs={7} mr={3} color={iconColor} from={iconFrom}>
        {icon}
      </FontIcon>
      <Div display="column">
        <Div color="gray8" fs={5} fw={3}>
          {title}
        </Div>
        <Div fs={2} color={descriptionColor}>
          {description}
        </Div>
      </Div>
    </Div>
    {buttons}
  </Div>
);

export { Page, Divider, Label, Title };
